import { EmployeeWorkingTime } from "../employee/employee-working-time";

export class Office {
    public id: number;
    public locationId: number;
    public systemId: number;
    public name: string;
    public floor: string;
    public workTimes: EmployeeWorkingTime[];
    public isChanged: boolean;
}